/**
 * Referral ranking table + current-rank min-deposit (languages not fully covered in panelSettingsTransactions).
 */
export const panelReferralRankingByLang = {
  pt: {
    'user.referral.ranking.tableTitle': 'Sistema de ranking',
    'user.referral.ranking.loading': 'A carregar rankings…',
    'user.referral.ranking.loadError':
      'Não foi possível carregar os rankings. Atualize a página ou tente mais tarde.',
    'user.referral.ranking.col.rank': 'Rank',
    'user.referral.ranking.col.minDeposit': 'Depósito mín.',
    'user.referral.ranking.col.monthlyIncome': 'Rendimento mensal',
    'user.referral.ranking.col.directRefs': 'Refs diretos',
    'user.referral.ranking.col.extraCommission': 'Comissão extra',
    'user.referral.ranking.badgeYou': 'Você',
    'user.referral.currentRank.minDeposit': '· {{amount}} depósito mín.',
  },
  it: {
    'user.referral.ranking.tableTitle': 'Sistema di ranking',
    'user.referral.ranking.loading': 'Caricamento ranking…',
    'user.referral.ranking.loadError':
      'Impossibile caricare i ranking. Aggiorna la pagina o riprova più tardi.',
    'user.referral.ranking.col.rank': 'Grado',
    'user.referral.ranking.col.minDeposit': 'Deposito min.',
    'user.referral.ranking.col.monthlyIncome': 'Reddito mensile',
    'user.referral.ranking.col.directRefs': 'Ref diretti',
    'user.referral.ranking.col.extraCommission': 'Commissione extra',
    'user.referral.ranking.badgeYou': 'Tu',
    'user.referral.currentRank.minDeposit': '· {{amount}} deposito min.',
  },
  ru: {
    'user.referral.ranking.tableTitle': 'Система рангов',
    'user.referral.ranking.loading': 'Загрузка рейтинга…',
    'user.referral.ranking.loadError':
      'Не удалось загрузить рейтинг. Обновите страницу или попробуйте позже.',
    'user.referral.ranking.col.rank': 'Ранг',
    'user.referral.ranking.col.minDeposit': 'Мин. депозит',
    'user.referral.ranking.col.monthlyIncome': 'Месячный доход',
    'user.referral.ranking.col.directRefs': 'Прямые реф.',
    'user.referral.ranking.col.extraCommission': 'Доп. комиссия',
    'user.referral.ranking.badgeYou': 'Вы',
    'user.referral.currentRank.minDeposit': '· {{amount}} мин. депозит',
  },
  bn: {
    'user.referral.ranking.tableTitle': 'র‍্যাঙ্কিং সিস্টেম',
    'user.referral.ranking.loading': 'র‍্যাঙ্কিং লোড হচ্ছে…',
    'user.referral.ranking.loadError':
      'র‍্যাঙ্কিং লোড করা যায়নি। পৃষ্ঠা রিফ্রেশ করুন বা পরে আবার চেষ্টা করুন।',
    'user.referral.ranking.col.rank': 'র‍্যাঙ্ক',
    'user.referral.ranking.col.minDeposit': 'ন্যূনতম জমা',
    'user.referral.ranking.col.monthlyIncome': 'মাসিক আয়',
    'user.referral.ranking.col.directRefs': 'সরাসরি রেফ.',
    'user.referral.ranking.col.extraCommission': 'অতিরিক্ত কমিশন',
    'user.referral.ranking.badgeYou': 'আপনি',
    'user.referral.currentRank.minDeposit': '· {{amount}} ন্যূন. জমা',
  },
  hi: {
    'user.referral.ranking.tableTitle': 'रैंकिंग सिस्टम',
    'user.referral.ranking.loading': 'रैंकिंग लोड हो रही है…',
    'user.referral.ranking.loadError':
      'रैंकिंग लोड नहीं हो सकी। पृष्ठ रिफ्रेश करें या बाद में पुनः प्रयास करें।',
    'user.referral.ranking.col.rank': 'रैंक',
    'user.referral.ranking.col.minDeposit': 'न्यूनतम जमा',
    'user.referral.ranking.col.monthlyIncome': 'मासिक आय',
    'user.referral.ranking.col.directRefs': 'प्रत्यक्ष रेफ.',
    'user.referral.ranking.col.extraCommission': 'अतिरिक्त कमीशन',
    'user.referral.ranking.badgeYou': 'आप',
    'user.referral.currentRank.minDeposit': '· {{amount}} न्यूनतम जमा',
  },
  'zh-CN': {
    'user.referral.ranking.tableTitle': '等级体系',
    'user.referral.ranking.loading': '正在加载等级…',
    'user.referral.ranking.loadError': '无法加载等级数据。请刷新页面或稍后再试。',
    'user.referral.ranking.col.rank': '等级',
    'user.referral.ranking.col.minDeposit': '最低入金',
    'user.referral.ranking.col.monthlyIncome': '月收入',
    'user.referral.ranking.col.directRefs': '直推',
    'user.referral.ranking.col.extraCommission': '额外佣金',
    'user.referral.ranking.badgeYou': '你',
    'user.referral.currentRank.minDeposit': '· 最低入金 {{amount}}',
  },
};

/** Min-deposit label next to current rank (de, es, fr, ar, ja, ko — ranking table already in panelSettingsTransactions). */
export const panelReferralCurrentRankMinDepositByLang = {
  de: { 'user.referral.currentRank.minDeposit': '· {{amount}} Mindesteinzahlung' },
  es: { 'user.referral.currentRank.minDeposit': '· {{amount}} depósito mín.' },
  fr: { 'user.referral.currentRank.minDeposit': '· {{amount}} dépôt min.' },
  ar: { 'user.referral.currentRank.minDeposit': '· {{amount}} حد إيداع أدنى' },
  ja: { 'user.referral.currentRank.minDeposit': '· 最低入金 {{amount}}' },
  ko: { 'user.referral.currentRank.minDeposit': '· 최소 입금 {{amount}}' },
};
